import styled from 'styled-components'

export const StyledPre = styled.pre`
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break:break-all;
`
